module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAYAAADJEc7MAAAAtklEQVR4AYyPsQ6CMBRF2/KFOvADxhCNOhA6dGMkYYQEJ1d+g9HNb2BxYdZoWn32NtHUSgyEk1zuu2dAMPsUZdMW5Z6m0bRWYU68XcSCM3ZC8Q9ssMXGiXmeXCNuZpxoQDkOH7DBFncnImTZpn8+TGyztoSvJiNibN6Hj4hCqW1HjFJkn4jxVKll53dfIg5KrmridEAGyFImNbLPj4jjuddr+79HgIwuZFSsqt3daDEHyKGE7xcAAAD//9DYozwAAAAGSURBVAMA7NBiiWTtkn8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/caret-down.png
// module id = +q9h
// module chunks = 2